import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="fixed bottom-0 left-0 w-full bg-gray-800 text-white py-1">
      <div className="container mx-auto text-center">
        <p>Pagos seguros con la tecnología de Stripe</p>
      </div>
    </footer>
  );
};

export default Footer;
